if (!customElements.get("video-banner-player")) {
  customElements.define(
    "video-banner-player",
    class VideoBannerPlayer extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector("video");
        if (!this.video || this.bound) return;
        this.bound = true;

        this.unmute();
        this.hideControls();
        this.video.addEventListener("playing", () => this.classList.add("video-banner__video--started"), {
          once: true,
        });
        this.video.addEventListener(
          "loadedmetadata",
          () => {
            this.unmute();
            this.hideControls();
          },
          { once: true },
        );
        // Seeking also fires "pause"; only reset once playback has really stopped.
        this.video.addEventListener("pause", () =>
          setTimeout(() => {
            if (!this.video.seeking && this.video.paused) this.stop();
          }, 150),
        );
        this.video.addEventListener("ended", () => this.stop());
        this.querySelector("[data-video-banner-play]")?.addEventListener("click", () => this.toggle());
      }

      unmute() {
        this.video.removeAttribute("muted");
        this.video.muted = false;
      }

      showControls() {
        this.video.setAttribute("controls", "");
        this.video.controls = true;
      }

      hideControls() {
        this.video.removeAttribute("controls");
        this.video.controls = false;
      }

      start() {
        this.classList.add("video-banner__video--playing");
        this.showControls();
      }

      stop() {
        this.classList.remove("video-banner__video--playing");
        this.hideControls();
      }

      toggle() {
        if (!this.video.paused && !this.video.ended) {
          this.video.pause();
          this.stop();
          return;
        }

        this.unmute();
        this.video
          .play()
          .then(() => this.start())
          .catch(() => {
            // Autoplay policy refused sound: play muted instead.
            this.video.muted = true;
            this.video
              .play()
              .then(() => this.start())
              .catch(() => {});
          });
      }
    },
  );
}
